import React from 'react';
import { Link } from './Link';
import styles from './TwitterButton.module.scss';
import {ReactComponent as TwitterIcon} from '../../assets/twitter.svg';
import { GLOBAL } from '../../App';

export class TwitterButton extends React.Component
{
	render()
	{
		// console.log(GLOBAL.router.normalize('https://twitter.com/ProjectPlateau'));
		return (
			<Link href={'https://twitter.com/ProjectPlateau'} decoration={false} arrow={false} className={['round', styles['twitter-button']].join(' ')}>
				<div className={styles['icon']}>
					<TwitterIcon></TwitterIcon>
				</div>
				<span className={styles['label']}>最新情報は<br />Twitterをフォロー</span>
			</Link>
		);
	}
}